<template>
    <span>
        <b-icon
            :icon="icon"
            :variant="iconVariant"
            ref="popoverIcon"
        ></b-icon>
        <b-popover 
            :target="getTarget"
            :title="title"
            :placement="placement"
            :triggers="triggers"
            :variant="popoverVariant"
            custom-class="shadow base-popover-icon-content"
        >
            <slot>{{content}}</slot>
        </b-popover>
    </span>
</template>

<script>
export default {
    name: 'BasePopoverIcon',
    props: {
        title: {
            type: String,
            required: true,
        },
        content: {  // string to show in main popover body -- cannot coexist with slot content
            type: String,
            required: false,
        },
        icon: {  // name of Bootstrap icon to use
            type: String,
            default: 'info-circle'
        },
        placement: {  // options are top, right, left, bottom, and all combinations   
            // https://bootstrap-vue.org/docs/components/popover
            type: String,
            default: 'top',
        },
        triggers: {  // options are 'click', 'hover', 'focus' -- can be array of multiple
            type: [String, Array],
            default: function() {
                return ['hover', 'focus'];
            },
        },
        iconVariant: {  // theme color variant to apply to icon
            type: String,
            default: 'secondary'
        },
        popoverVariant: {  // theme color variant to apply to popover
            type: String,
            default: ''
        }
    },
    data: function() {
        return {
        }
    },
    methods: {
        getTarget: function() {
            return this.$refs.popoverIcon;
        },
    }
}
</script>

<style>

</style>